import axios from 'axios'
import constants from '../../../constants'

const getCorpChildrenDevices = async (customerNumber: string, queryParms?: string) => {
  const query = queryParms ?? ''
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-devices/corp-children${query}`)
  return response.data
}

export {
  getCorpChildrenDevices
}